<template>
  <div>
    <mq-layout :mq="['sm', 'md']">
      <MobileHeader :social="true" />
    </mq-layout>
    <mq-layout mq="lg+">
      <header id="header" class="header" :class="$mq">
        <div class="header__content">
          <nav id="navi">
            <BaseNavigation />
          </nav>
          <nav v-if="kinofinder" id="finder">
            <BaseKinofinder v-if="$config.kinoservice.display" />
          </nav>
        </div>
        <component
          :is="companySocial"
          :instagram="true"
          :facebook="true"
          :youtube="false"
          :teilen="false"
          v-if="social"
          class="header__social"
        ></component>
      </header>
    </mq-layout>
  </div>
</template>

<script>
export default {
  props: {
    social: {
      type: Boolean,
      default: true,
    },
    kinofinder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    companySocial() {
      return () =>
        import(
          `@/website_elements/global/companies/${this.$config.verantwortlich.toLowerCase()}/Social.vue`
        )
    },
  },
}
</script>

<style lang="scss" scoped>
.bgc {
  background-color: #fff !important;
}
.header {
  $self: &;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--height-header);
  background-color: var(--clr-blau);
  z-index: 9999;
  overflow: hidden;
  &__content {
    margin-left: 50%;
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: row;
    padding: var(--p-header);
    padding-left: -120px;
    height: var(--height-header);
    font-weight: var(--fw-header);
    @media (max-width: 1400px) {
      margin-left: 0;
    }
  }
  &__social {
    position: absolute;
    top: 0px;
    left: 15px;
    text-align: right;
  }
}
</style>
